﻿import { Component, OnInit } from '@angular/core';
import { DataService } from '../../shared/dataservice.service';



@Component({
  selector: 'app-grn-stic-plan',
  templateUrl: './grn-stic-plan.component.html',
  styleUrls: ['./grn-stic-plan.component.css']
})
export class GrnSticPlanComponent implements OnInit {
  hasmodaccess: boolean = false;
  mId: string = "6e333b36-7125-4c4f-0445-0af4d51397f8";
  selView:number = 0;
 

  constructor(private _dataService:DataService) { }

  ngOnInit() {
    this._dataService.currPageName = "Green Sticker Plan Highlights";

  }

  checkModAccess(): boolean {
    if (this._dataService.mAccess(this.mId) == true) {
      this.hasmodaccess = true;
    }
    else {
      this.hasmodaccess = false;
    }
    return this.hasmodaccess;
  }
  public setView(_viewNo: number): void {
    this.selView = _viewNo;
  }
  

 
}
